<template>
    <el-drawer title="时间日程" :append-to-body="true" size="23%" :visible.sync="visibleDrawer"
        custom-class="insideDrawe insideDraweNew flcu-box" @close="close">
        <!-- 添加日程盒子 -->
        <div class="addrc-box" @click="openBjschedule(false)">
            <img src="@/assets/image/product/tianjia.png" alt="" />
            <div>点击添加时间日程</div>
        </div>
        <div class="line"></div>
        <!-- 列表 -->
        <div class="schedule-list-new" v-if="scheduleList.length">
            <div class="item" v-for="(item, index) in scheduleList" :key="index">
                <div class="item-header" @click="openCkschedule(item)">
                    <div class="header-left">
                        <img v-if="item.cycle == '1'" src="@/assets/image/product/shizhong.png" alt="" />
                        <img v-if="item.cycle == '2'" src="@/assets/image/product/meizhou.png" alt="" />
                        <img v-if="item.cycle == '3'" src="@/assets/image/product/rili.png" alt="" />
                        <span v-if="item.cycle == '1'">
                            <span>每天执行</span>
                        </span>
                        <span v-if="item.cycle == '2'">
                            <span v-if="item.cycleContent">{{ exerciseDate(item.cycleContent) }}</span>
                            <span v-else>--</span>
                        </span>
                        <span v-if="item.cycle == '3'">
                            <span v-if="item.cycleContent">{{ item.cycleContent.replace('-', '年').replace('-', '月') + '日' }}</span>
                            <span v-else>--</span>
                        </span>
                    </div>
                    <div class="header-right">
                        <img v-if="item.state == '1'" src="@/assets/image/product/qiyong.png" alt=""
                            @click.stop="statusClick(item)" />
                        <img v-else src="@/assets/image/product/jinyong.png" alt="" @click.stop="statusClick(item)" />
                    </div>
                </div>
                <div class="item-top" @click="openCkschedule(item)">
                    <template v-if="item.dcTaskPeriodList && item.dcTaskPeriodList.length">
                        <div class="lie-1 lie-2" v-for="(ele, ind) in item.dcTaskPeriodList.slice(0, 2)" :key="ind">
                            <div>
                                {{ ele.periodName || '--' }}：
                                <span>{{ item.mode == '0' ? ele.startTime || '--' : (ele.startTime && ele.endTime ? ele.startTime + '~' + ele.endTime : '--') }}{{ ind == 1 && item.dcTaskPeriodList.length > 2 ? '等' + item.dcTaskPeriodList.length + '个' + (item.mode == '0' ? '时间' : '时段') : '' }}</span>
                            </div>
                        </div>
                    </template>
                    
                    <div class="lie-1">
                        <div>是否生效：<span v-if="item.state == '1'">已生效</span><span v-else>未生效</span></div>
                    </div>
                </div>
                <div v-if="item.state == '0'" class="item-bottom">
                    <div class="cz-div green" @click="openBjschedule(true, item)">
                        <img src="@/assets/image/product/icon-bj.png" alt="" />
                        编辑
                    </div>
                    <div class="cz-line"></div>
                    <div class="cz-div red" @click="timeDayDel(item)">
                        <img src="@/assets/image/product/icon-sc.png" alt="" />
                        删除
                    </div>
                </div>
            </div>
        </div>
        <div class="schedule-list-new-no" v-else>
            <img src="@/assets/image/home/ZWT.png" alt="" />
        </div>
        <!-- 查看时间日程 -->
        <el-drawer title="查看详情" :append-to-body="true" size="23%" :visible.sync="insideSwitch.ckschedule" custom-class="insideDrawe insideDraweNew flcu-box" @close="ckscheduleClose">
            <div style="width: 100%;height: 100%;display: flex;flex-direction: column;position: relative;">
                <div class="del-title">
                    <img v-if="detailTimer.cycle == '1'" src="@/assets/image/product/shizhong.png" alt="" />
                    <img v-if="detailTimer.cycle == '2'" src="@/assets/image/product/meizhou.png" alt="" />
                    <img v-if="detailTimer.cycle == '3'" src="@/assets/image/product/rili.png" alt="" />
                    <span v-if="detailTimer.cycle == '1'">每天执行</span>
                    <span v-if="detailTimer.cycle == '2'">{{ detailTimer.cycleContent ? exerciseDate(detailTimer.cycleContent) : '--' }}</span>
                    <span v-if="detailTimer.cycle == '3'">{{ detailTimer.cycleContent ? detailTimer.cycleContent.replace('-', '年').replace('-', '月') + '日' : '--' }}</span>
                </div>
                <div class="delaction-box">
                    <div class="delaction-li" v-for="(item, index) in detailTimer.dcTaskPeriodList" :key="index">
                        <div class="delli-title">{{ item.periodName || '--' }}</div>
                        <div class="delli-setting dborder-bottom">
                            <div class="delli-set-item">
                                <span class="label">{{ detailTimer.mode == '0' ? '定点' : '时段' }}设置</span>
                                <span class="value">{{ detailTimer.mode == '0' ? item.startTime || '--' : (item.startTime && item.endTime ? item.startTime + '~' + item.endTime : '--') }}</span>
                            </div>
                            <div v-if="detailTimer.mode == '1'" class="delli-set-item" style="margin-top:0.3rem;">
                                <span class="label">时段内循环间隔</span>
                                <span class="value">{{ item.cycleInterval ? changeNumToStr(item.cycleInterval) : '--' }}</span>
                            </div>
                        </div>
                        <div class="delli-setting">
                            <div class="delli-set-item">
                                <span class="label">执行动作</span>
                                <span class="value">{{ item.operateName || '--' }}</span>
                            </div>
                            <!-- 开关类 -->
                            <div v-if="infos.subDeviceType == '2-1'" class="delli-set-item" style="margin-top: 0.33rem;">
                                <span class="label">动作保持时间</span>
                                <span class="value">{{ item.holdTime ? changeNumToStr(item.holdTime) : '--' }}</span>
                            </div>
                            <!-- 行程类 -->
                            <div v-if="infos.subDeviceType == '2-2'" class="delli-set-item" style="margin-top: 0.33rem;">
                                <span class="label">设置开合度</span>
                                <span class="value">{{ item.holdTime ? item.holdTime + '%' : '--' }}</span>
                            </div>
                            <div class="delli-set-node">
                                <span>{{ item.operateNode || '--' }}</span>
                                <span v-if="infos.subDeviceType == '2-1' && !item.holdTime">（未设置则持续运行）</span>
                                <span v-if="infos.subDeviceType == '2-2' && !item.holdTime">
                                    {{item.operate == '01' || item.operate == '1' ? '（未设置则到最大位置停止）' : '（未设置则到最小位置停止）'}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
        <!-- 编辑时间日程 -->
		<el-drawer :title="isBjSchedule ? '编辑' : '时间日程'" :append-to-body="true" size="23%" :visible.sync="insideSwitch.bjschedule" custom-class="insideDrawe insideDraweNew flcu-box" @close="bjscheduleClose">
			<div style="width: 100%;height: 100%;display: flex;flex-direction: column;position: relative;" v-loading="bjscheduleloading">
                <template v-if="!isBjSchedule">
                    <div class="prompts-title-new prompts-title-notop">执行类型选择</div>
                    <div class="time-mode-box">
                        <el-radio-group v-model="timercFrom.mode">
                            <div class="time-mode-li" :class="{ 'active': timercFrom.mode == '0' }" @click="modeChange('0')">
                                <div class="time-mode-li-left">
                                    <img class="icon" src="@/assets/image/product/fixedtime.png" alt="" />
                                    <div class="time-mode-li-left-msg">
                                        <span class="msgtitle">定点执行</span>
                                        <span class="msgnode">到达指定时间执行</span>
                                    </div>
                                </div>
                                <el-radio label="0"></el-radio>
                            </div>
                            <div class="time-mode-li" :class="{ 'active': timercFrom.mode == '1' }" @click="modeChange('1')">
                                <div class="time-mode-li-left">
                                    <img class="icon1" src="@/assets/image/product/timeslot.png" alt="" />
                                    <div class="time-mode-li-left-msg">
                                        <span class="msgtitle">时间段执行</span>
                                        <span class="msgnode">到达指定时间执行</span>
                                    </div>
                                </div>
							    <el-radio label="1"></el-radio>
						    </div>
                        </el-radio-group>
                    </div>
                </template>
				<div class="prompts-title-new" :class="{ 'prompts-title-notop': isBjSchedule }">执行日期选择</div>
				<div class="time-type-box">
					<el-radio-group v-model="timercFrom.cycle">
						<div class="time-type-li" @click="timercFrom.cycle = '1'">
							<div class="li-head">每天<el-radio label="1"></el-radio></div>
						</div>
						<div class="time-type-li" @click="timercFrom.cycle = '2'">
							<div class="li-head">每周执行<el-radio label="2"></el-radio></div>
							<div class="li-bottom" :class="{ 'li-bottom-show': timercFrom.cycle == '2', 'border-b': timercFrom.mode == '1' }">
								<el-checkbox-group v-model="timercFrom.checkList">
									<el-checkbox label="1">周一</el-checkbox>
									<el-checkbox label="2">周二</el-checkbox>
									<el-checkbox label="3">周三</el-checkbox>
									<el-checkbox label="4">周四</el-checkbox>
									<el-checkbox label="5">周五</el-checkbox>
									<el-checkbox label="6">周六</el-checkbox>
									<el-checkbox label="7">周日</el-checkbox>
								</el-checkbox-group>
							</div>
						</div>
						<div v-if="timercFrom.mode == '0'" class="time-type-li" @click="timercFrom.cycle = '3'">
							<div class="li-head">指定日期<el-radio label="3"></el-radio></div>
							<div class="li-bottom border-b" :class="{ 'li-bottom-show': timercFrom.cycle == '3', }">
								<div class="picktime-box">
									<el-date-picker v-model="timercFrom.pickTime" size="small" type="date"
										placeholder="请选择日期" popper-class="pick-poper" class="picker-div"
										format="yyyy-MM-dd" value-format="yyyy-MM-dd" prefix-icon=" "
										clear-icon="el-icon-date" :clearable="false" :editable="false"
										:picker-options="pickerOptions0">
									</el-date-picker>
									<i class="pick-icon el-icon-date"></i>
								</div>
							</div>
						</div>
					</el-radio-group>
				</div>
				<div class="prompts-title-new">执行动作<div v-if="!timercFrom.dcTaskPeriodList || timercFrom.dcTaskPeriodList.length < limitTimeLength" class="prompts-title-btn" @click="addActionTime">添加{{timercFrom.mode == '0' ? '时间点' : '时间段'}}</div></div>
				<div class="zxaction-box-new">
                    <div class="zxaction-li"  v-for="(item, index) in timercFrom.dcTaskPeriodList" :key="index">
                        <div class="li-title">
                            <div v-show="inputPeriodNameIndex !== index" class="title-msg font_14">
                                {{ item.periodName }}
                                <img @click="showEditName(item, index)" src="@/assets/image/product/icon-edit.png" alt="" />
                            </div>
                            <div v-show="inputPeriodNameIndex == index" class="input-div">
                                <el-input placeholder="请输入内容" v-model="inputPeriodName" :maxlength="6">
                                    <i slot="suffix" class="suffix-content">
                                        <img src="@/assets/image/product/queding.png" alt="" @click.stop="confirmEditName(item)" />
                                        <img src="@/assets/image/product/quxiao.png" alt="" @click.stop="cnacelEditName()" />
                                    </i>
                                </el-input>
                            </div>
                            <img class="delimg" src="@/assets/image/product/icon-sc.png" alt="" @click="deleteTimeAction(index)"/>
                        </div>
                        <div class="li-setting border-bottom">
                            <div v-show="timercFrom.mode == '0'" class="li-set-item">
                                <span class="label">时间点设置</span>
                                <div class="timepicker-box">
                                    <el-time-picker v-model="item.startTime" placeholder="请选择" :clearable="false" value-format="HH:mm:ss"> </el-time-picker>
                                    <i class="el-icon-arrow-down right-icon"></i>
                                </div>
                            </div>
                            <div v-show="timercFrom.mode == '1'">
                                <div class="li-set-item">
                                    <span class="label">时段设置</span>
                                    <div class="timepicker-box time-range">
                                        <el-time-picker v-model="item.rangeTime" is-range start-placeholder="开始时间" end-placeholder="结束时间" placeholder="请选择" :clearable="false" range-separator="~" value-format="HH:mm:ss"> </el-time-picker>
                                        <i class="el-icon-arrow-down right-icon"></i>
                                    </div>
                                </div>
                                <div class="li-set-item">
                                    <span class="label">时段内循环间隔</span>
                                    <div class="timepicker-box time-text">
                                        <el-time-picker v-model="item.cycleInterval" @focus="item.cycleInterval = item.cycleInterval || '00:00:00'" placeholder="请选择" :clearable="false" format="HH时mm分ss秒" value-format="HH:mm:ss"> </el-time-picker>
                                        <i class="el-icon-arrow-down right-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="li-setting">
                            <div class="li-set-item">
                                <span class="label">执行动作</span>
                                <div class="radio-box">
                                    <el-radio-group v-model="item.operate" @change="(val) => operateChange(val, item)">
                                        <el-radio v-for="(item, index) in commandsItemList" :key="index" :label="item.commandsItemCode">{{ item.commandsItemName }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <!-- 开关类 -->
                            <div v-show="infos.subDeviceType == '2-1' && item.operate !== '-1'" class="li-set-item">
                                <span class="label">动作保持时间</span>
                                <div class="timepicker-box time-text" :class="{ 'clear-text': timercFrom.mode == '0' && item.holdTime }">
                                    <el-time-picker ref="timePoint" v-model="item.holdTime" @focus="item.holdTime = item.holdTime || '00:00:00'" placeholder="请选择" :clearable="false" format="HH时mm分ss秒" value-format="HH:mm:ss"> </el-time-picker>
                                    <i class="el-icon-arrow-down right-icon"></i>
                                    <i class="el-icon-circle-close right-icon" @click="item.holdTime = ''"></i>
                                </div>
                            </div>
                            <!-- 行程类 -->
                            <div v-show="infos.subDeviceType == '2-2' && item.operate !== '-1'" class="li-set-item">
                                <span class="label">设置开合度</span>
                                <div class="select-box" :class="{ 'clear-text': timercFrom.mode == '0' && item.khdValue }">
                                    <el-select v-model="item.khdValue" placeholder="请选择">
                                        <el-option v-for="item in khdOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                    <i class="el-icon-arrow-down right-icon"></i>
                                    <i class="el-icon-circle-close right-icon" @click="item.khdValue = ''"></i>
                                </div>
                            </div>
                            <div class="li-set-node" v-if="item.operate !== '-1'">{{ item.operateNode || '' }}</div>
                        </div>
                    </div>
				</div>
				<!-- 确定按钮 -->
				<div class="btn-box-new">
					<div class="btn-item" @click="scheduleupto">保存并下发</div>
				</div>
			</div>
            <!-- 确定删除时间点、时间段信息警告 -->
            <div class="Information" :class="{ 'Information-show': timeInformation }">
                <div class="top">确定删除该{{ timercFrom.mode == '0' ? '时间' : '时段' }}吗？</div>
                <div class="bottom">
                    <div @click="delTimeCancle">取消</div>
                    <div class="line"></div>
                    <div class="green" @click="delTimeSubmit">确定</div>
                </div>
            </div>
			<Msg ref="tsmsg2"></Msg>
		</el-drawer>
        <!-- 确定删除信息警告 -->
        <div class="Information" :class="{ 'Information-show': Information }">
            <div class="top">确定删除吗？</div>
            <div class="bottom">
                <div @click="scheduleCancle">取消</div>
                <div class="line"></div>
                <div class="green" @click="scheduleSubmit">确定</div>
            </div>
        </div>
        <Msg ref="tsmsg"></Msg>
    </el-drawer>
</template>

<script>
import Msg from '@/components/msg.vue' //信息提示组件
export default {
    components: { Msg },
    data() {
        return {
            infos: {}, // 上个页面传递过来的参数

            visibleDrawer: false,
            scheduleList: [],

            limitLength: 0, // 时间日程限制数量
			limitTimeLength: 0, // 时间点或时间段限制数量

            durationData: {}, // 时长配置对象，用于根据开合度计算执行时间，传递给后台

            Information: false,
            InformationId: "",

            detailTimer: {}, // 查看详情时间日程

            isBjSchedule: false, // 时间日程是否是编辑操作，主要用过添加和编辑的区分
            // 控制里面抽屉的开关
			insideSwitch: {
                ckschedule: false, //查看时间日程
				bjschedule: false, //编辑时间日程
			},
            //   时间日程编辑表单
			defaultTimerc: {
                mode: '0', // 执行类型
				cycle: '1', //1每天2每周3指定日期
				checkList: ['1'], // 按周的选中值
				pickTime: '', // 指定日期的时间
                dcTaskPeriodList: [], // 执行动作时间列表
			},
			timercFrom: {
                mode: '0', // 执行类型
				cycle: '1', //1每天2每周3指定日期
				checkList: ['1'], // 按周的选中值
				pickTime: '', // 指定日期的时间
                dcTaskPeriodList: [], // 执行动作时间列表
			},
            commandsItemList: [], // 操作
            inputPeriodNameIndex: -1, // 时间点时间段编辑名称索引
            inputPeriodName: '', // 时间点时间段编辑的名称
            timeInformation: false, // 删除时间点、时间段警告
            deleteTimeIndex: -1, // 删除时间点、时间段索引
            pickerOptions0: {
				disabledDate: (time) => {
					let num = new Date().getTime()
					return time.getTime() < num - 86400000
				},
			},
            khdOptions: [], // 开合度选项
            bjscheduleloading: false,
        }
    },
    created() {
        this.khdOptions = []
		for (var i = 0; i <= 100; i++) {
			this.khdOptions.push({label: i.toString().padStart(2, '0') + '%', value: i.toString().padStart(2, '0')})
		}
    },
    watch: {
		infos: {
			handler(newValue) {
				console.log(newValue, '传过来的设备信息')
			},
			deep: true,
			immediate: true,
		},
	},
    methods: {
        open() {
            this.visibleDrawer = true;
            this.getTimeList()
            if (this.infos.subDeviceType == '2-2') {
                this.commandsItemList = this.infos.commandsItemList ? this.infos.commandsItemList.filter(obj => obj.commandsItemCode !== '0' && obj.commandsItemCode !== '00') : []
                this.getDurationData()
            } else {
                this.commandsItemList = this.infos.commandsItemList
            }
        },
        getDurationData() {
            this.$http.getAction(this.$api.queryDuration + "?deviceNum=" + this.infos.deviceNum + "&subDeviceNum=" + this.infos.subDeviceNum).then((res) => {
                if (res.code == 200 && res.data) {
                    this.durationData = res.data
                }
            })
        },
        close() {
            // 关闭删除确认框
            this.scheduleCancle()
        },

        // 获取时间日程列表数据
		getTimeList() {
			let params = {
				deviceId: this.infos.deviceId,
				subNo: this.infos.subDeviceNum,
			}
			this.$http.postAction(this.$api.dcTaskList, params).then((res) => {
				if (res.code == 200) {
					let datas = res.data || []
					this.scheduleList = datas || []
				} else {
					this.scheduleList = []
				}
			})
		},
        // 时间日程-日期显示处理
		exerciseDate(val) {
			let arr = val.split(',')
            arr.sort((a, b) => a - b);
			let newArr = []
			arr.forEach((item) => {
				newArr.push(this.weekTran(item))
			})
			let result = `${newArr.join('、')}`
			return result
		},
        // 周几转化
		weekTran(num) {
			if (num == 1) {
				return '周一'
			} else if (num == 2) {
				return '周二'
			} else if (num == 3) {
				return '周三'
			} else if (num == 4) {
				return '周四'
			} else if (num == 5) {
				return '周五'
			} else if (num == 6) {
				return '周六'
			} else {
				return '周日'
			}
		},

        // 查看时间日程
        openCkschedule(item) {
            if (item.dcTaskPeriodList && item.dcTaskPeriodList.length) {
                item.dcTaskPeriodList.forEach(obj => {
                    if (obj.operate) {
                        let commandsItemList = this.infos.commandsItemList
                        if (commandsItemList) {
                            let operateObjIndex = commandsItemList.findIndex(cobj => cobj.commandsItemCode == obj.operate)
                            if (operateObjIndex !== -1) {
                                obj.operateName = commandsItemList[operateObjIndex].commandsItemName
                                obj.operateNode = this.getOperateNode(commandsItemList[operateObjIndex], operateObjIndex)
                            }
                        }
                    }
                })
            }
            this.detailTimer = item
            this.insideSwitch.ckschedule = true
        },
        // 关闭查看时间日程
        ckscheduleClose() {

        },
        // 秒数转换为时分秒
        changeNumToStr(seconds) {
			const hour = Math.floor(seconds / 3600);
			const minute = Math.floor((seconds % 3600) / 60);
			const second = seconds % 60;
			return hour + '时' + minute + '分' + second + '秒';
		},
        changeNumToPStr(seconds) {
			const hour = (Math.floor(seconds / 3600)).toString().padStart(2, '0');
			const minute = (Math.floor((seconds % 3600) / 60)).toString().padStart(2, '0');
			const second = (seconds % 60).toString().padStart(2, '0');
			return hour + ':' + minute + ':' + second;
		},
        // 获取操作说明
        getOperateNode(oitem, oindex, mode = '') {
            let commandsItemList = this.infos.commandsItemList
			let operateChooseName = ''
			// 定点执行
			if (this.infos.subDeviceType == '2-1') {
				// 开关类设备
				if (oindex == 0) operateChooseName = oitem.commandsItemName + '保持多长时间后' + commandsItemList[1].commandsItemName
				if (oindex == 1) operateChooseName = oitem.commandsItemName + '保持多长时间后' + commandsItemList[0].commandsItemName
                if (mode == '0') {
                    // 新增或编辑定点设置
                    operateChooseName += '（选填，未设置则持续运行）'
                }
			}
			if (this.infos.subDeviceType == '2-2') {
				// 行程类设备
                operateChooseName = '每次执行都按设定的开合度运行后自动停止'
				if (oitem.commandsItemCode == '01' || oitem.commandsItemCode == '1') {
					// 上升
                    if (mode == '0') {
                        // 新增或编辑定点设置
                        operateChooseName += '（未设置则到最大位置停止）'
                    }
				} else {
					// 下降
                    if (mode == '0') {
                        // 新增或编辑定点设置
                        operateChooseName += '（未设置则到最小位置停止）'
                    }
				}
			}
			return operateChooseName
		},

        // 删除
        timeDayDel({ id }) {
			this.Information = true
			this.InformationId = id
        },
        // 确定删除
        scheduleSubmit() {
            this.$http.deleteAction(this.$api.dcTaskDelete + '/' + this.InformationId).then((res) => {
				if (res.code == 200) {
					this.Information = false
					this.$refs.tsmsg.msgShow('删除成功', 1.5)
					// 重新请求数据
					this.$nextTick(() => {
						this.getTimeList()
					})
				} else {
					this.scheduleCancle()
					this.$message(res.msg, 'error')
				}
			})
        },
        // 取消删除
        scheduleCancle() {
            this.Information = false
			this.InformationId = ''
        },

        // 启用禁用状态切换
        async statusClick(item) {
            let params = {
				id: item.id,
				state: item.state == '1' ? '0' : '1',
			};
            if (this.infos.subDeviceType == '2-2') {
                // 行程类
                params.totalTime = this.durationData.onTotalDuration
            }
            this.$http.postAction(this.$api.dcTaskSwitchState, params).then((res) => {
				if (res.code == 200) {
					this.$refs.tsmsg.msgShow(params.state == '1' ? '该时间日程已启用' : '该时间日程已停用', 1.5)
					// 重新请求数据
					this.$nextTick(() => {
						this.getTimeList()
					})
				} else {
					this.Information = false
					this.InformationId = ''
					this.$refs.tsmsg.msgShow(res.msg, 1.5)
				}
			})
        },

        // 打开新增或编辑
        async openBjschedule(bool, editObj) {
            this.scheduleCancle() // 关闭时间日程删除框

            this.isBjSchedule = bool
            // 查询可新增数量
            try {
                let res = await this.$http.getAction(this.$api.getTaskNum + "?deviceNum=" + this.infos.deviceNum)
                if (res.code == 200 && res.data && res.data[0]) {
                    let datajson = JSON.parse(res.data[0])
					if (datajson.timing_period_len) {
						this.limitTimeLength = Number(datajson.timing_period_len)
					}
					if (datajson.timing_atno_len) {
						this.limitLength = Number(datajson.timing_atno_len)
					}
                } else {
                    this.$refs.tsmsg.msgShow(res.msg || '未查询到该设备相关时间日程配置信息', 1.5)
                    return
                }
            } catch (error) {
                this.$refs.tsmsg.msgShow(error.msg || '未查询到该设备相关时间日程配置信息', 1.5)
                return
            }

            if (!bool) {
                if (this.scheduleList.length >= this.limitLength) {
                    this.$refs.tsmsg.msgShow('当前设备时间日程不能超过' + this.limitLength + '个', 1.5)
					return;
				}
                this.modeChange('0') // 新增时默认
            } else {
                // 编辑
                let obj = {
                    id: editObj.id,
                    mode: editObj.mode, // 执行类型
				    cycle: editObj.cycle, //1每天2每周3指定日期
			    	checkList: editObj.cycle == '2' && editObj.cycleContent ? editObj.cycleContent.split(',') : ['1'], // 按周的选中值
			    	pickTime: editObj.cycle == '3' && editObj.cycleContent ? editObj.cycleContent : '', // 指定日期的时间
                    dcTaskPeriodList: [], // 执行动作时间列表
                }
                if (editObj.dcTaskPeriodList) {
                    editObj.dcTaskPeriodList.forEach(item => {
                        let formatItem = {
                            periodName: item.periodName || '',
                            startTime: item.startTime || '',
                            cycleInterval: item.cycleInterval ? this.changeNumToPStr(Number(item.cycleInterval)) : '',
							endTime: item.endTime || '',
                            operate: item.operate || '-1',
                            operateNode: item.operate ? this.getOperateToNode(item.operate, obj.mode) : ''
                        }
                        if (obj.mode == '1') {
                            // 时间段
                            formatItem.rangeTime = [item.startTime, item.endTime]
                        }
                        if (this.infos.subDeviceType == '2-2') {
							// 行程设备
                            formatItem.khdValue = item.holdTime ? item.holdTime.toString().padStart(2, '0') : ''
						} else {
							formatItem.holdTime = item.holdTime ? this.changeNumToPStr(Number(item.holdTime)) : ''
						}
                        obj.dcTaskPeriodList.push(formatItem)
                    })
                }
                this.timercFrom = obj
            }
			this.insideSwitch.bjschedule = true
        },
        // 时间日程类型切换
        modeChange(type) {
            this.timercFrom = JSON.parse(JSON.stringify(this.defaultTimerc))
            this.timercFrom.mode = type
            if (this.limitTimeLength > 0) this.addActionTime()
        },

        // 添加时间点或时间段
        addActionTime() {
            let obj = {}
            if (this.timercFrom.mode == '0') {
                // 定点
                obj = {
                    periodName: '时间' + (this.timercFrom.dcTaskPeriodList.length + 1),
                    startTime: '',
                    operate: '-1',
                    holdTime: '',
                    khdValue: ''
                }
            } else {
                // 时间段
                obj = {
                    periodName: '时段' + (this.timercFrom.dcTaskPeriodList.length + 1),
                    // startTime: '',
                    // endTime: '',
					cycleInterval: '',
					operate: '-1',
					holdTime: '',
                    khdValue: ''
                }
            }
            this.timercFrom.dcTaskPeriodList.push(obj)
        },

        // 编辑名称
        showEditName(item, index) {
            this.inputPeriodNameIndex = index
            this.inputPeriodName = item.periodName
            this.$forceUpdate()
        },
        confirmEditName(item) {
            item.periodName = this.inputPeriodName
            this.inputPeriodNameIndex = -1
            this.$forceUpdate()
        },
        // 取消编辑名称
        cnacelEditName() {
            this.inputPeriodNameIndex = -1
            this.$forceUpdate()
        },

        // 删除某个时间点或时间段
        deleteTimeAction(index) {
            this.timeInformation = true
            this.deleteTimeIndex = index
        },
        delTimeSubmit() {
			this.timercFrom.dcTaskPeriodList.splice(this.deleteTimeIndex, 1);
            this.delTimeCancle();
        },
        delTimeCancle() {
            this.timeInformation = false
            this.deleteTimeIndex = -1
        },

        // 执行动作变化
        operateChange(e, item) {
            item.operateNode = this.getOperateToNode(e, this.timercFrom.mode)
            this.$forceUpdate()
        },
        getOperateToNode(e, mode) {
            let commandsItemList = this.infos.commandsItemList
            if (commandsItemList) {
                let operateObjIndex = commandsItemList.findIndex(cobj => cobj.commandsItemCode == e)
                if (operateObjIndex !== -1) {
                    return this.getOperateNode(commandsItemList[operateObjIndex], operateObjIndex, mode)
                }
            }
            return ''
        },
        // 时间日程编辑页面点击下发
		scheduleupto() {
			if ((this.timercFrom.cycle == '2' && this.timercFrom.checkList.length == 0) || (this.timercFrom.cycle == '3' && !this.timercFrom.pickTime)) {
				this.$refs.tsmsg2.msgShow('请选择执行日期', 1.5)
			}
            if (this.timercFrom.dcTaskPeriodList && this.timercFrom.dcTaskPeriodList.length) {
                let dcTaskPeriodList = this.timercFrom.dcTaskPeriodList
				try {
					if (this.timercFrom.mode == '0') {
						// 定点
						for (let i = 0; i < dcTaskPeriodList.length; i++) {
                            if (!dcTaskPeriodList[i].startTime) throw '请选择' + dcTaskPeriodList[i].periodName + '的时间点';
                            if (dcTaskPeriodList[i].operate == '-1') throw '请选择' + dcTaskPeriodList[i].periodName + '的执行动作';
							for (let j = 0; j < dcTaskPeriodList.length; j++) {
								if (i !== j) {
									if (dcTaskPeriodList[i].startTime == dcTaskPeriodList[j].startTime) {
										throw '当前任务中不允许出现同一时间点';
									}
									if (this.infos.subDeviceType == '2-1') {
										// 开关类设备判断
										if (this.changeTimenumber(dcTaskPeriodList[i].holdTime)) {
											if ((this.changeTimenumber(dcTaskPeriodList[i].startTime) < this.changeTimenumber(dcTaskPeriodList[j].startTime)) && (this.changeTimenumber(dcTaskPeriodList[i].startTime) + this.changeTimenumber(dcTaskPeriodList[i].holdTime) > this.changeTimenumber(dcTaskPeriodList[j].startTime))) {
												throw dcTaskPeriodList[i].periodName + '和' + dcTaskPeriodList[j].periodName + '执行动作期间不允许交叉';
											}
										}
									}
								}
							}
						}
					} else {
						// 时间段执行
						for (let i = 0; i < dcTaskPeriodList.length; i++) {
                            if (!dcTaskPeriodList[i].rangeTime) throw '请选择' + dcTaskPeriodList[i].periodName + '的时段';
                            if (!dcTaskPeriodList[i].cycleInterval) throw '请选择' + dcTaskPeriodList[i].periodName + '的时段内循环间隔';
                            if (dcTaskPeriodList[i].operate == '-1') throw '请选择' + dcTaskPeriodList[i].periodName + '的执行动作';
							if (this.infos.subDeviceType == '2-1') {
                                if (!dcTaskPeriodList[i].holdTime) throw '请选择' + dcTaskPeriodList[i].periodName + '的动作保持时间';
								if (this.changeTimenumber(dcTaskPeriodList[i].holdTime) >= this.changeTimenumber(dcTaskPeriodList[i].cycleInterval)) {
									throw dcTaskPeriodList[i].periodName + '的动作保持时间不得大于或等于时段内循环间隔';
								}
							} else if (this.infos.subDeviceType == '2-2') {
                                if (!dcTaskPeriodList[i].khdValue) throw '请设置' + dcTaskPeriodList[i].periodName + '的开合度';
								if (Math.floor(parseInt(dcTaskPeriodList[i].khdValue) * this.durationData.onTotalDuration / 100) >= this.changeTimenumber(dcTaskPeriodList[i].cycleInterval)) {
									throw dcTaskPeriodList[i].periodName + '的运行时间不得大于或等于时段内循环间隔';
								}
							}
							// 时段差绝对值
							let timeSum = Math.abs(this.changeTimenumber(dcTaskPeriodList[i].rangeTime[1]) - this.changeTimenumber(dcTaskPeriodList[i].rangeTime[0]))
							// 循环时间
							let cycleTime = this.changeTimenumber(dcTaskPeriodList[i].cycleInterval)
							if (timeSum < cycleTime) {
								// 时段差小于时间循环间隔的话，提示
								throw dcTaskPeriodList[i].periodName + '的时段循环间隔不得大于时段设置时间';
							}

							for (let j = 0; j < dcTaskPeriodList.length; j++) {
								if (i !== j) {
									if (this.changeTimenumber(dcTaskPeriodList[i].rangeTime[0]) > this.changeTimenumber(dcTaskPeriodList[j].rangeTime[0]) && this.changeTimenumber(dcTaskPeriodList[i].rangeTime[0]) < this.changeTimenumber(dcTaskPeriodList[j].rangeTime[1])) {
										throw dcTaskPeriodList[i].periodName + '和' + dcTaskPeriodList[j].periodName + '不允许时间交叉';
									}
									if (this.changeTimenumber(dcTaskPeriodList[i].rangeTime[1]) > this.changeTimenumber(dcTaskPeriodList[j].rangeTime[0]) && this.changeTimenumber(dcTaskPeriodList[i].rangeTime[1]) < this.changeTimenumber(dcTaskPeriodList[j].rangeTime[1])) {
										throw dcTaskPeriodList[i].periodName + '和' + dcTaskPeriodList[j].periodName + '不允许时间交叉';
									}
								}
							}
						}
					}
				} catch (error) {
                    this.$refs.tsmsg2.msgShow(error, 1.5)
					return;
				}
			} else {
                this.$refs.tsmsg2.msgShow('请添加' + (this.timercFrom.mode == '0' ? '时间点' : '时间段'), 1.5)
				return;
            }

            this.bjscheduleloading = true;
            let submitparam = {}
            submitparam.deviceId = this.infos.deviceId
			submitparam.subNo = this.infos.subDeviceNum

            if (this.infos.subDeviceType == '2-2') {
				// 行程类设备
				submitparam.totalTime = this.durationData.onTotalDuration
			}

            // 定时任务模式 0定点 ，1 时间段
			submitparam.mode = this.timercFrom.mode

            // 每日
			if (this.timercFrom.cycle == '1') {
				submitparam.cycle = '1'
				submitparam.cycleContent = ''
                submitparam.taskName = '每天执行'
			}
			// 每周
			if (this.timercFrom.cycle == '2') {
				submitparam.cycle = '2'
				submitparam.cycleContent = this.timercFrom.checkList.join(',')
                submitparam.taskName = submitparam.cycleContent ? this.exerciseDate(submitparam.cycleContent) : ''
			}
			// 指定日期
			if (this.timercFrom.cycle == '3') {
				submitparam.cycle = '3'
				submitparam.cycleContent = this.timercFrom.pickTime
                submitparam.taskName = submitparam.cycleContent ? submitparam.cycleContent.replace('-', '年').replace('-', '月') + '日' : ''
			}
			submitparam.dcTaskPeriodList = []

            this.timercFrom.dcTaskPeriodList.forEach(item => {
				let obj = {
                    periodName: item.periodName,
					subNo: this.infos.subDeviceNum,
					operate: item.operate,
                }
				if (this.timercFrom.mode == '0') {
					obj.startTime = item.startTime
				} else {
                    obj.startTime = item.rangeTime[0]
                    obj.cycleInterval = this.changeTimenumber(item.cycleInterval)
                    obj.endTime = item.rangeTime[1]
				}
                if (this.infos.subDeviceType == '2-2') {
					// 行程类设备
					obj.holdTime = item.khdValue
				} else if (this.infos.subDeviceType == '2-1') {
					// 开关类
					obj.holdTime = this.changeTimenumber(item.holdTime)
				}
				submitparam.dcTaskPeriodList.push(obj)
			})

            if (this.isBjSchedule) {
				// 编辑
				submitparam.id = this.timercFrom.id
                this.$http.putAction(this.$api.dcTaskUpdate, submitparam).then((res) => {
                    if (res.code == 200) {
                        this.insideSwitch.bjschedule = false
                        this.$refs.tsmsg.msgShow('下发成功', 1.5)
                        // this.getTimeList();
                    } else {
                        this.$refs.tsmsg2.msgShow(res.msg, 1.5)
                    }
					this.bjscheduleloading = false;
                }).catch((err) => {
					this.$refs.tsmsg2.msgShow(err.msg, 1.5)
					this.bjscheduleloading = false;
				})
			} else {
				// 新增
				submitparam.number = this.limitLength
				this.$http.postAction(this.$api.dcTaskSave, submitparam).then((res) => {
                    if (res.code == 200) {
                        this.insideSwitch.bjschedule = false
                        this.$refs.tsmsg.msgShow('下发成功', 1.5)
                        // this.getTimeList();
                    } else {
                        this.$refs.tsmsg2.msgShow(res.msg, 1.5)
                    }
					this.bjscheduleloading = false;
                }).catch((err) => {
					this.$refs.tsmsg2.msgShow(err.msg, 1.5)
					this.bjscheduleloading = false;
				})
			}
		},
        changeTimenumber(time) {
            const [hour, minute, second] = time.split(':').map(Number);
			return hour * 3600 + minute * 60 + second;
        },
        // 编辑时间日程关闭
		bjscheduleClose() {
            this.cnacelEditName()
            this.delTimeCancle()
			this.getTimeList()
		},
    },
}
</script>

<style lang="scss" scoped>
::v-deep .insideDraweNew {
    .el-drawer__body {
		padding: 0 0.3rem 0;
    }

    .line {
		height: 1px;
		background: #f1f1f1;
		margin: 0.3rem 0;
	}

    .schedule-list-new {
        height: 80%;
        overflow: auto;
        padding-right: 4px;
      // 背景
        &::-webkit-scrollbar {
            width: 8px;
            height: 0px;
            background-color: transparent;
            border-radius: 4px;
        }
        
        // 背景
        &::-webkit-scrollbar-track {
            width: 8px;
            height: 8px;
            background-color: transparent;
            border-radius: 4px;
        }
        
        // 滚动条
        &::-webkit-scrollbar-thumb {
            width: 8px;
            height: 8px;
            border-radius: 4px;
            background-color: rgba(45, 174, 169, 0.2);
        }
        .item {
            background: #e7f1f3;
            border-radius: 0.125rem;
            overflow: hidden;
            margin-bottom: 0.3rem;
            font-size: 0.2rem;

            .item-header {
                display: flex;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 0.225rem 0.3rem;
                border-bottom: 1px solid rgba(255, 255, 255, 0.6);

                .header-left {
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #333333;
                    line-height: 28px;
                    display: flex;
                    align-items: center;


                    img {
                        width: 0.225rem;
                        height: 0.225rem;
                        margin-right: 0.175rem;
                    }

                    .gray {
                        color: #5e5353;
                    }
                }

                .header-right {
                    margin-left: 0.45rem;

                    img {
                        cursor: pointer;
                    }
                }
            }

            .item-top {
                box-sizing: border-box;
                padding: 0.25rem 0.3rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                position: relative;

                .r-jiao {
                    position: absolute;
                    top: 0.1375rem;
                    right: -0.3125rem;
                    width: 1.25rem;
                    height: 0.3875rem;
                    background: rgba(45, 174, 169, 1);
                    text-align: center;
                    line-height: 0.3875rem;
                    color: white;
                    transform: rotate(45deg);
                }

                .r-jiao-no {
                    background: rgba(213, 213, 213, 1);
                }

                .lie-1 {
                    display: flex;

                    &>div {
                        flex: 1;
                        font-size: 0.2rem;

                        span {
                            font-size: 0.2rem;
                        }
                    }
                }
                .lie-2 {
                    margin-bottom: .3rem;
                }
            }

            .item-bottom {
                height: 0;
                overflow: hidden;
                transition: all 0.5s;
                box-sizing: border-box;

                border-top: 1px solid rgba(255, 255, 255, 0.6);
                display: flex;
                justify-content: space-around;

                .cz-div {
                    cursor: pointer;
                    display: flex;
                    align-items: center;

                    img {
                        margin-right: 0.15rem;
                    }
                }

                .cz-line {
                    width: 0.0125rem;
                    background: rgba(255, 255, 255, 0.6);
                }

                .blue {
                    color: rgba(43, 137, 217, 1);
                }

                .green {
                    color: rgba(45, 174, 169, 1);
                }

                .red {
                    color: rgba(227, 52, 52, 1);
                }
            }
        }

        .item:hover {
            .item-bottom {
                height: 0.7125rem;
                display: flex;
                padding: 0.125rem;
            }
        }
    }

    .schedule-list-new-no {
        height: 80%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .del-title {
        display: flex;
        align-items: center;
        margin-bottom: 0.26rem;
        font-weight: bold;
        font-size: 0.2rem;
        color: #333333;

        img {
            width: 0.23rem;
            height: 0.23rem;
            margin-right: 0.1rem;
        }
    }

    .delaction-li {
        background: #F2F8F9;
        border-radius: 0.14rem;
        border: 1px solid #EFEFEF;
        margin-bottom: 0.26rem;
        padding: 0 0.1rem;

        .delli-title {
            padding: 0.23rem 0.09rem 0.19rem 0.14rem;
            border-bottom: 1px solid #EEEEEE;
            font-size: 0.17rem;
            color: #8B8B8B;
        }

        .delli-setting {
            padding: 0.16rem 0.16rem 0.23rem 0.14rem;

            .delli-set-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                // margin-bottom: 0.2rem;

                .label {
                    font-size: 0.2rem;
                    color: #181818;
                }

                .value {
                    font-size: 0.2rem;
                    color: #848484;
                }
            }

            .delli-set-node {
                margin-top: 0.19rem;

                span {
                    font-size: 0.18rem;
                    color: #ACACAC;
                }
            }

            &.dborder-bottom {
                padding: 0.23rem 0.16rem 0.2rem 0.14rem;
                border-bottom: 1px solid #EEEEEE;
            }
        }
    }

    .prompts-title-new {
		position: relative;
		margin-top: 0.2875rem;
		display: flex;
		align-items: center;
        position: relative;

        &.prompts-title-notop {
            margin-top: 0;
        }

		&::before {
			margin-right: 0.3rem;
			content: '';
			width: 0.025rem;
			height: 0.2rem;
			background: #2daea9;
		}

        .prompts-title-btn {
            cursor: pointer;
            width: 1.46rem;
            height: 0.36rem;
            background: rgba(52, 146, 234, 0.1);
            border-radius: 0.18rem;
            font-size: 0.2rem;
            color: #3492EA;
            text-align: center;
            line-height: 0.36rem;
            position: absolute;
            right: -0.12rem;
        }
	}

    .time-mode-box {
        margin-top: 0.09rem;

        .el-radio-group {
			width: 100%;
		}

        .time-mode-li {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 0.13rem;
            border: 1px solid #EAEAEA;
            padding: 0.19rem 0.28rem 0.19rem 0.21rem;
            margin-top: 0.16rem;

            .time-mode-li-left {
                display: flex;
                align-items: center;

                .icon {
                    width: 0.36rem;
                    height: 0.43rem;
                }

                .icon1 {
                    width: 0.36rem;
                    height: 0.36rem;
                }

                .time-mode-li-left-msg {
                    display: flex;
                    flex-direction: column;
                    margin-left: 0.19rem;

                    .msgtitle {
                        color: #333333;
                        font-size: 0.2rem;
                    }

                    .msgnode {
                        color: #999999;
                        margin-top: 0.14rem;
                        font-size: 0.18rem;
                    }
                }
            }

            .el-radio__label {
				display: none;
			}

            &.active {
                background: #F2F8F9;
                border: 1px solid #2DAEA9;
            }
        }
    }

    .time-type-box {
		margin-top: 0.25rem;

		.el-radio-group {
			width: 100%;
		}

		.time-type-li {
			.li-head {
				cursor: pointer;
				box-sizing: border-box;
				height: 0.55rem;
				background: #f2f8f9;
				border: 1px solid #eeeeee;
				padding-left: 0.3125rem;
				padding-right: 0.3rem;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.el-radio__label {
					display: none;
				}
			}

			.li-bottom {
				height: 0;
				overflow: hidden;
				transition: all 0.5s;
				box-sizing: border-box;
				border-left: 1px solid #eeeeee;
				border-right: 1px solid #eeeeee;
                border-bottom: 0px solid #eeeeee;
				padding: 0 0.3125rem;

				.el-radio-group {
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: space-between;

					.input-box {
						display: inline-block;
						// width: 49px;
						height: 22px;
						margin: 0 0.05rem;
					}
				}

				.el-checkbox-group {
					display: flex;
					flex-wrap: wrap;

					// align-items: center;
					.el-checkbox:nth-child(1) {
						margin-bottom: 18px;
					}

					.el-checkbox {
						margin-right: 28px;
					}
				}

				.picktime-box {
					position: relative;
					width: 4.3rem;
					height: 0.45rem;
					margin: 0.125rem auto 0;

					.el-date-editor.el-input,
					.el-date-editor.el-input__inner {
						width: 100%;
					}

					.pick-icon {
						position: absolute;
						right: 0.25rem;
						top: 45%;
						transform: translateY(-50%);
						font-size: 0.25rem;
						color: #e5e5e5;
					}
				}
			}

			.li-bottom-show {
				padding: 0.2rem 0.3125rem;
				height: 1.125rem;
			}

			.border-b {
				border-bottom: 1px solid #eeeeee;
			}
		}
	}

    .zxaction-box-new {
		margin-top: 0.12rem;
		display: flex;
        flex-direction: column;

        .zxaction-li {
            background: #F2F8F9;
            border-radius: 0.14rem;
            border: 1px solid #EFEFEF;
            margin-top: 0.13rem;
            padding: 0 0.1rem;

            .li-title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0.11rem 0.09rem 0.11rem 0.04rem;
                border-bottom: 1px solid #EEEEEE;

                .title-msg {
                    display: flex;
                    align-items: center;
                    color: #8B8B8B;
                    line-height: 0.36rem;
                    margin-left: 0.1rem;

                    img {
                        cursor: pointer;
                        width: 0.16rem;
                        height: 0.16rem;
                        margin-left: 0.14rem;
                    }
                }

                .input-div {
					width: 2.64rem;
                    height: 0.36rem;
					.el-input {
						height: 100%;
					}
					.el-input__inner {
						height: 100%;
						font-weight: normal;
                        padding-left: 0.16rem;
                        padding-right: 0.93rem;
                        background: transparent;
                        border-radius: 0.05rem;
                        border: 1px solid #E2E2E2;
					}
					.el-input.is-active .el-input__inner,
					.el-input__inner:focus {
						border-color: #E2E2E2;
					}
					.el-input__suffix {
						height: 100%;
                        right: 0;
						.el-input__suffix-inner {
							display: block;
							width: 100%;
							height: 100%;
							display: flex;
							align-items: center;
							.suffix-content {
								display: flex;
								align-items: center;
								box-sizing: border-box;
								justify-content: space-around;
								padding: 0 0 0 0.19rem;
								img {
									cursor: pointer;
									width: 0.18rem;
									height: 0.18rem;
                                    margin-right: 0.19rem;
								}
							}
						}
					}
				}

                .delimg {
                    cursor: pointer;
                    width: 0.23rem;
                    height: 0.25rem;
                }
            }

            .li-setting {
                padding: 0.16rem 0.16rem 0 0.14rem;

                .li-set-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 0.24rem;

                    .label {
                        font-size: 0.2rem;
                        color: #181818;
                    }

                    .timepicker-box {
                        width: 1.28rem;
                        position: relative;

                        .el-date-editor.el-input,
                        .el-date-editor.el-input__inner {
                            width: 100%;
                        }

                        .el-date-editor {
                            position: relative;
                            z-index: 9;

                            .el-input__inner {
                                padding: 0 0.29rem 0 0.11rem;
                                text-align: right;
                                font-size: 0.2rem;
                                color: #848484;
                                height: 0.28rem;
                                line-height: 0.28rem;
                                border: none;
                                background: transparent;
                            }
                            .el-input__prefix {
                                display: none;
                            }
                        }

                        .right-icon {
                            cursor: pointer;
                            position: absolute;
                            right: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            z-index: 5;
                            color: #C0C4CC;
                            font-size: 14px;
                        }

                        .el-icon-circle-close.right-icon {
                            display: none;
                            z-index: 10;
                        }

                        &.time-range {
                            width: 2.08rem;

                            .el-date-editor {
                                height: 0.28rem;
                                line-height: 0.28rem;
                                border: none;
                                background: transparent;
                                padding: 0 0.29rem 0 0.11rem;

                                .el-range-separator {
                                    width: max-content;
                                    padding: 0;
                                    line-height: 0.28rem;
                                }

                                .el-input__icon {
                                    display: none;
                                }

                                .el-range-input {
                                    flex: 1;
                                    background: transparent;
                                    text-align: center;
                                    font-size: 0.2rem;
                                    color: #848484;
                                }
                            }
                        }

                        &.time-text {
                            width: 1.7rem;
                        }

                        &.clear-text:hover {
                            .el-icon-arrow-down.right-icon {
                                display: none;
                            }
                            .el-icon-circle-close.right-icon {
                                display: block;
                            }
                        }
                    }

                    .radio-box {
                        .el-radio {
                            .el-radio__label {
                                font-size: 0.2rem;
                                color: #181818;
                            }

                            &.is-checked {
                                .el-radio__label {
                                    color: #181818 !important;
                                }
                            }
                        }
                    }

                    .select-box {
                        width: 1.1rem;
                        position: relative;

                        .el-select {
                            position: relative;
                            z-index: 9;

                            .el-input {
                                .el-input__inner {
                                    padding: 0 0.29rem 0 0.11rem;
                                    text-align: right;
                                    font-size: 0.2rem;
                                    color: #848484;
                                    height: 0.28rem;
                                    line-height: 0.28rem;
                                    border: none;
                                    background: transparent;
                                }
                                .el-input__suffix {
                                    display: none;
                                }
                            }
                        }

                        .right-icon {
                            cursor: pointer;
                            position: absolute;
                            right: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            z-index: 5;
                            color: #C0C4CC;
                            font-size: 14px;
                        }

                        .el-icon-circle-close.right-icon {
                            display: none;
                            z-index: 10;
                        }

                        &.clear-text:hover {
                            .el-icon-arrow-down.right-icon {
                                display: none;
                            }
                            .el-icon-circle-close.right-icon {
                                display: block;
                            }
                        }
                    }
                }

                .li-set-node {
                    font-size: 0.18rem;
                    color: #ACACAC;
                    margin-bottom: 0.24rem;
                }

                &.border-bottom {
                    padding: 0.23rem 0.16rem 0 0.14rem;
                    border-bottom: 1px solid #EEEEEE;
                }
            }
        }

		// .el-radio-group {
		// 	.el-radio {
		// 		margin-right: 1.05rem;
		// 	}
		// }
	}

    .btn-box-new {
        flex: 1;
		// position: relative;
		display: flex;
		justify-content: space-around;
		align-items: flex-end;
        width: 100%;
        position: sticky;
        bottom: 0;
        background: #fff;
        padding: 0.15rem 0;

		.btn-item {
			box-sizing: border-box;
			border: 0.0125rem solid #2daea9;
			cursor: pointer;
			width: 1.75rem;
			height: 0.45rem;
			background: #2daea9;
			border-radius: 0.05rem;
			text-align: center;
			line-height: 0.45rem;
			color: white;
		}

		.cancel {
			background: #fff;
			color: #2daea9;
		}
	}
}
</style>